import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";
import { Button } from "@deere/fuel-react";

const RejectReasonModal = ({ open, onClose, onConfirm, reason, onReasonChange, isBatch }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Reject Transaction{isBatch ? "s" : ""}</DialogTitle>
    <DialogContent>
      {isBatch && (
        <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>
          This reason will be applied to all selected transactions.
        </Typography>
      )}
      <TextField
        autoFocus
        margin="dense"
        label="Reason for Rejection"
        type="text"
        fullWidth
        multiline
        rows={3}
        value={reason}
        onChange={onReasonChange}
        required
      />
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={onConfirm}
        disabled={!reason.trim()}
      >
        Reject
      </Button>
    </DialogActions>
  </Dialog>
);

export default RejectReasonModal;
